import { render, staticRenderFns } from "./PaletteCatalogThumbnail.vue?vue&type=template&id=8eada4e6&"
import script from "./PaletteCatalogThumbnail.vue?vue&type=script&lang=js&"
export * from "./PaletteCatalogThumbnail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports